export default "__VITE_ASSET__pY63fnvv__"